import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.brightsmilesplan-container': {
    '& .normal-text': {
      fontWeight: 300,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        marginTop: 72,
        background: palette.background.header,
        '& .hero-header-subtitle, .hero-header-title': {
          color: palette.text.primary,
        },
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.header,

      '& .home-hero-pretitle': {
        paddingBottom: 32,
      },

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (max-width: 900px)': {
            marginTop: 32,
          },
        },
      },
      '& .home-hero-title': {
        maxWidth: 500,
        fontWeight: 'bold',
        '@media screen and (max-width: 900px)': {
          textAlign: 'center',
        },
      },
      '& .home-hero-subtitle': {
        maxWidth: 490,
        '@media screen and (max-width: 900px)': {
          textAlign: 'center',
        },
      },
      '& .login-button': {
        background: palette.secondary.main,
        color: palette.text.highlight,
        borderColor: palette.secondary.main,
      },
      // for bigger screens ie for 32 inch screen
      '@media screen and (min-width: 1800px)': {
        height: '900px',
      },
      '& .section-header__cta-container': {
        '@media screen and (max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.footer,
    },
    '& .definition-variant-2': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',

      '@media(max-width: 900px)': {
        paddingTop: 0,
      },

      '& .benefits-wrapper': {
        '& .section-header__title': {
          paddingBottom: 64,

          '@media(max-width: 900px)': {
            paddingBottom: 24,
          },
        },
        '& .definition-service-title': {
          fontSize: 24,
          fontWeight: 600,
        },
        '& .definition-service-description-wrapper': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .definition-service-description': {
          fontSize: 16,
          fontWeight: 400,
          paddingBottom: 40,
          color: '#64748B',
          borderBottom: `none`,

          '@media(min-width: 900px)': {
            maxWidth: 400,
          },
        },
      },
      '@media(min-width: 900px)': {
        '& .section-alternate__content': {
          paddingLeft: '74px !important',
        },
        '& .definition-service-innertile': {
          width: 'calc(100% + 16px) !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.main,
      '& .subscription-bg': {
        height: '100%',
      },
      '& .subscription-section': {
        minHeight: 'auto',
      },
      '& .desc-box': {
        display: 'none',
      },
      '& .title-box': {
        marginBottom: 40,
      },
      '& .section-header__title, .section-header__subtitle, .rating, .savings-summary-link':
        {
          color: palette.text.highlight,
        },
      '& .getstarted-button-desktop': {
        background: '#FFD84C',
        color: palette.text.primary,
      },
      '& .rating': {
        fontSize: 18,
        paddingBottom: 12,
        '@media(max-width: 900px)': {
          textAlign: 'center',
        },
      },
      '& .description-section': {
        backgroundColor: palette.divider,
      },
      '& .price-item': {
        background: palette.background.footer,
      },
      '& .getstarted-button-container': {
        '@media(max-width: 900px)': {
          justifyContent: 'center',
        },
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .price-value': {
            color: palette.text.primary,
          },
          '& .customGetStarted': {
            width: '96%',
          },
          '& .customCardContent': {
            background: palette.text.highlight,
            padding: '32px 24px',
            '& .cardDivider, .customPlanDescription': {
              display: 'none',
            },
            '& .price-item': {
              marginBottom: 0,
            },
          },
          '& .customBenefitsContainer': {
            minHeight: 180,
          },
        },
        '& .review-box': {
          '& .review': {
            paddingTop: '0px !important',
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          fontSize: 16,
          cursor: 'pointer',
        },
      },
      '@media(min-width: 900px)': {
        '& .section-header__title': {
          fontSize: 56,
        },
        '& .section-header__subtitle': {
          maxWidth: 650,
          fontSize: 20,
        },
        '& .left-section': {
          paddingLeft: 48,
        },
      },
      '@media(max-width: 900px)': {
        '& .section-header__title': {
          fontSize: 40,
          textAlign: 'center',
        },
        '& .description-section': {
          marginTop: 12,
          margin: 'auto',
          textAlign: 'center',
        },
        '& .review-box': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginBottom: 32,
        },
        '& .section-header__subtitle': {
          maxWidth: 590,
          fontSize: 20,
          textAlign: 'center',
        },
      },
      '& .react-multi-carousel-dot button': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        background: palette.text.highlight,
        border: 'none',
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .section-header__title': {
        fontWeight: 'normal',
      },
      '& .how-cover-image': {
        height: 450,
      },
      '& .step-counter': {
        backgroundColor: palette.background.main,
        color: palette.text.highlight,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
      '@media(max-width: 900px)': {
        '& .how-cover-image': {
          height: '100%',
        },
      },
      '@media(min-width: 900px)': {
        '& .howitworks-title': {
          marginBottom: 32,
        },
        '& .howitworks-wrapper': {
          paddingLeft: 40,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      background: palette.background.footer,
      '& .hero-static-title': {
        fontWeight: 'normal',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        background: palette.background.footer,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.primary.main}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.divider,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
      '& .hero-static-bg': {
        background: `${palette.background.footer} !important`,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0',
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0,
        },
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
      },
    },
    '& .footer-bar': {
      backgroundColor: palette.background.main,
    },
    '& .view-more-button': {
      background: palette.secondary.main,
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'auto',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '84px',
        maxWidth: '84px',
      },
      '& .provider-contact-link': {
        fontSize: 20,
        fontWeight: 'bold',
      },
      '& .provider-contact-details': {
        color: palette.text.secondary,
        fontWeight: 400,
      },
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
      '& .stepperIconActive': {
        color: `${palette.primary.main} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.primary.main,
        '& .stepperIconText': {
          fill: palette.primary.main,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.primary.main,
      },
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.background.alternate,
      color: palette.text.highlight,
      '& .footer-link, .copyrights-footer-link': {
        color: palette.text.highlight,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
    },
  },
};
